import React, { FunctionComponent, SVGProps } from 'react';
import styled from 'styled-components';

interface TransferIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const TransferIcon: FunctionComponent<TransferIconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <g>
        <circle cx="12" cy="12" r="12" fill="#E6E7EB" />
        <g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5051 12.5896L9.92223 14.154L15.6458 14.1756C15.7918 14.1761 15.9315 14.2347 16.0343 14.3384C16.137 14.4421 16.1943 14.5824 16.1935 14.7284C16.1928 14.8743 16.1341 15.0139 16.0305 15.1166C15.9268 15.2192 15.7865 15.2764 15.6407 15.2756L9.91812 15.2545L11.48 16.8348C11.5828 16.9384 11.6402 17.0785 11.6396 17.2244C11.6391 17.3703 11.5805 17.51 11.4769 17.6127C11.2609 17.8264 10.9126 17.8248 10.6985 17.6091L8.1297 15.0151C7.95478 14.8373 7.95708 14.5514 8.13484 14.3765L10.7309 11.8077C10.9467 11.594 11.2949 11.5956 11.5087 11.8112C11.6115 11.9149 11.6689 12.0552 11.6682 12.2012C11.6675 12.3472 11.6089 12.4869 11.5051 12.5896Z"
            fill="#32343C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9729 7.94116L14.5558 9.50558L8.83224 9.52716C8.68626 9.5277 8.54649 9.58628 8.44376 9.68999C8.34102 9.79369 8.28374 9.934 8.28456 10.08C8.28524 10.2259 8.34388 10.3655 8.44757 10.4681C8.55126 10.5707 8.69149 10.628 8.83737 10.6271L14.5599 10.6061L12.9981 12.1864C12.8953 12.2899 12.8378 12.4301 12.8384 12.576C12.839 12.7219 12.8975 12.8615 13.0011 12.9643C13.2172 13.178 13.5655 13.1764 13.7795 12.9607L16.3483 10.3667C16.5232 10.1889 16.5209 9.90297 16.3432 9.72804L13.7471 7.15921C13.5313 6.94553 13.1831 6.94714 12.9693 7.16281C12.8665 7.26648 12.8092 7.40675 12.8098 7.55273C12.8105 7.69871 12.8692 7.83844 12.9729 7.94116Z"
            fill="#32343C"
          />
        </g>
      </g>
    </svg>
  );
};

export default styled(TransferIcon)`
  width: 24px;
  height: 24px;

  .circle {
    fill: ${({ theme }) => theme.colors.inputBackgroundAlternateDark};
  }

  .path {
    fill: ${({ theme }) => theme.colors.primary};
  }

  &.inverted {
    .circle {
      fill: ${({ theme }) => theme.colors.primaryHover};
    }

    .path {
      fill: ${({ theme }) => theme.colors.differentBackground};
    }
  }
`;
